import { render, staticRenderFns } from "./CampoDescuento.vue?vue&type=template&id=012a45a1"
import script from "./CampoDescuento.vue?vue&type=script&lang=js"
export * from "./CampoDescuento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports